import configuration from "./index";
import { authFetch } from "../utils/authFetch";

const TemplateAPI = {
  get: async function (problemID) {
    const api = configuration.apiBase + `/problem/${problemID}/templates`;

    const response = await authFetch(api)
      .then((res) => res.json())
      .then((result) => {
        return result.templates;
      });

    return response;
  },

  lastCommunication: async function (problemID) {
    const api =
      configuration.apiBase + `/problem/${problemID}/communications/latest`;

    const response = await authFetch(api)
      .then((res) => {
        res.json();
      })
      .then((result) => {
        return result;
      });

    return response;
  },
};

export { TemplateAPI };
